<p-drawer
  [(visible)]="visible"
  position="right"
  styleClass="efetivo-drawer-dark user-drawer-dark"
  [modal]="true"
  [closable]="true"
  header="Editar Utilizador"
  (onHide)="closeDrawer()"
>
  <!-- Corpo -->
  <div class="modal-body">
    <form [formGroup]="userForm" (ngSubmit)="onSubmit()" class="form-sections">
      <div class="form-section">
        <h4 class="form-section-title">
          <i class="pi pi-id-card"></i> Dados de Conta
        </h4>

        <!-- ── FOTOGRAFIA (opcional) ── -->
        <div class="foto-section">
          <div class="foto-wrap">
            <div class="foto-circle" (click)="fotoInput.click()">
              <img
                *ngIf="fotoPreviewUrl"
                [src]="fotoPreviewUrl"
                alt="Fotografia do utilizador"
                class="foto-img"
              />
              <div *ngIf="!fotoPreviewUrl" class="foto-placeholder">
                <i class="pi pi-camera"></i>
                <span>Foto</span>
              </div>
              <div class="foto-overlay">
                <i class="pi pi-pencil"></i>
              </div>
            </div>
            <input
              #fotoInput
              type="file"
              accept="image/jpeg,image/png,image/webp"
              hidden
              (change)="onFotoSelect($event)"
            />
          </div>

          <div class="foto-info">
            <p class="foto-hint">Fotografia do utilizador</p>
            <div class="foto-actions">
              <button
                type="button"
                class="btn-web-secondary"
                (click)="fotoInput.click()"
              >
                <i class="pi pi-upload"></i>
                {{ selectedFoto ? "Alterar foto" : "Trocar foto" }}
              </button>
              <button
                type="button"
                class="btn-web-secondary"
                *ngIf="selectedFoto"
                (click)="removeFoto()"
              >
                <i class="pi pi-trash"></i>
              </button>
            </div>
            <small *ngIf="selectedFoto" class="foto-selected-name">
              <i
                class="pi pi-check-circle"
                style="color: var(--green, #22c55e)"
              ></i>
              {{ selectedFoto.name }}
            </small>
            <small *ngIf="!selectedFoto" class="foto-meta"
              >JPG, PNG, WEBP · Máx. 5 MB · Opcional — mantém a foto atual se
              não trocar</small
            >
          </div>
        </div>

        <div class="form-grid-1">
          <div class="form-group">
            <label class="form-label">NIF (Username) *</label>
            <input
              pInputText
              type="text"
              formControlName="userName"
              placeholder="Ex: 000000000LA000"
              class="form-input"
              [class.ng-invalid]="submitted && f['userName'].errors"
            />
            <div *ngIf="submitted && f['userName'].errors" class="error-msg">
              <small *ngIf="f['userName'].errors['required']"
                >NIF é obrigatório.</small
              >
              <small *ngIf="f['userName'].errors['minlength']"
                >NIF deve ter pelo menos 3 caracteres.</small
              >
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Nome Completo *</label>
            <input
              pInputText
              type="text"
              formControlName="nome"
              placeholder="Ex: João da Silva"
              class="form-input"
              [class.ng-invalid]="submitted && f['nome'].errors"
            />
            <div *ngIf="submitted && f['nome'].errors" class="error-msg">
              <small *ngIf="f['nome'].errors['required']"
                >Nome completo é obrigatório.</small
              >
              <small *ngIf="f['nome'].errors['minlength']"
                >Nome deve ter pelo menos 3 caracteres.</small
              >
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">E-mail *</label>
            <input
              pInputText
              type="email"
              formControlName="email"
              placeholder="Ex: joao.silva@securpro.com"
              class="form-input"
              [class.ng-invalid]="submitted && f['email'].errors"
            />
            <div *ngIf="submitted && f['email'].errors" class="error-msg">
              <small *ngIf="f['email'].errors['required']"
                >E-mail é obrigatório.</small
              >
              <small *ngIf="f['email'].errors['email']"
                >Formato de e-mail inválido.</small
              >
            </div>
          </div>

          <div class="form-group">
            <label class="form-label">Perfil de Utilizador</label>
            <p-select
              formControlName="tipoPerfil"
              [options]="perfilOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Selecione o perfil"
              styleClass="w-full"
              appendTo="body"
            >
            </p-select>

            <div *ngIf="isCliente" class="perfil-lock-warning">
              <i class="pi pi-lock"></i>
              <span>
                <strong>Perfil Imutável:</strong> O perfil <strong>Cliente</strong> representa a entidade contratante do serviço e não pode ser alterado após a sua criação.
              </span>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>

  <!-- Ações -->
  <div class="modal-actions-footer">
    <div class="modal-actions">
      <button type="button" class="btn-web-secondary" (click)="closeDrawer()">
        Cancelar
      </button>
      <button
        type="button"
        class="btn-web-primary"
        (click)="onSubmit()"
        [disabled]="loading"
      >
        <i class="pi pi-check"></i>
        {{ loading ? "A guardar..." : "Guardar Alterações" }}
      </button>
    </div>
  </div>
</p-drawer>
